module.exports = __webpack_public_path__ + "b2f7285a54f798a9426dcc5ea0b3e478.woff2";